import App from '../pageview/app.vue'
import store from '../store/store'
import Promotion from '../pageview/app/promotion'
import Channel from '../pageview/app/channel'
import Region from '../pageview/app/region'

const beforeEnter = (to, from, next) => {
  //重置state上的Loading
  store.state.tableLoading = false
  store.state.chartLoading = false

  next(true);
}

export default {
  path: 'app',
  component: App,
  redirect: '/app/promotion',
  children: [{
      path: 'promotion',
      component: Promotion,
      beforeEnter
    },{
      path: 'channel',
      component: Channel,
      beforeEnter
    },{
      path: 'region',
      component: Region,
      beforeEnter
    }]
}



// WEBPACK FOOTER //
// ./src/router/app-router.js